// 验证方法
export var maxMin = function (max, min) {
    return withParams({type: maxMin}, function (value) {
      return !!value && max > value && min < value
    })
  }
export var phone = /^1(3|4|5|6|7|8|9)\d{9}$/
//密码强度正则，最少6位，包括，1个数字
export var password = /^.{6,20}$/
// export var password = /^.*(?=.{6,16})(?=.*\d).*$/
// 用户名//用户名正则，4到16位（字母，数字，下划线，减号）
export var username = /^[a-zA-Z0-9_-]{6,16}$/
// 验证码
export var qrcode = /^[0-9]\d{6}$/
export var onlyNumber = /^\d+$/
export var onlyLetter = /^[a-zA-Z]+$/
// 身份证
export var idCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
export var bankNo = /^(\d{16}|\d{19})$/
export var realName = /^[\u4E00-\u9FA5]{2,4}$/
export var realnameMoney = /^[1-9]\d*(\.\d+)?$/
// 邮箱
export var isEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
export var money = /^[0-9]+(.[0-9]{2})?$/
// export var telCode = regex('telCode', /^\d{6}$/)
// export var telCode = regex('telCode', /^\d{4}$/)
export var hasBlank = /\s/
export var integer = /^[1-9]\d*$/